var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconNavBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 20,
  height: 20
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "icon-nav-back_svg__a",
  d: "M0 0h20v20H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "rotate(90 10 10)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "icon-nav-back_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#icon-nav-back_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#4545FF",
  strokeWidth: 2,
  d: "M3.333 6.667 10 13.333l6.667-6.666",
  mask: "url(#icon-nav-back_svg__b)",
  transform: "rotate(90 10 10)"
}))));
export { SvgIconNavBack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iZjR2ZW9namoyYSIgZD0iTTAgMEgyMFYyMEgweiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8Zz4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIwMCAtNDI4KSB0cmFuc2xhdGUoNjc2IDM5NCkgcm90YXRlKDkwIDI1NSAyODkpIj4KICAgICAgICAgICAgICAgICAgICA8bWFzayBpZD0iMXZyeTduaG5wYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2Y0dmVvZ2pqMmEiLz4KICAgICAgICAgICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggc3Ryb2tlPSIjNDU0NUZGIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0zLjMzMyA2LjY2N0wxMCAxMy4zMzMgMTYuNjY3IDYuNjY3IiBtYXNrPSJ1cmwoIzF2cnk3bmhucGIpIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAxMCAxMCkiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";